// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CashCardOrderStartEvent
 */
export var CashCardOrderStart = function () { return ({
    name: "CashCard Order Start",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Order",
    }
}); };
/**
 * @see CashCardOrderSubmitEvent
 */
export var CashCardOrderSubmit = function (_a) {
    var cardTheme = _a.cardTheme;
    return ({
        name: "CashCard Order Submit",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Order",
            card_theme: cardTheme !== undefined && cardTheme !== null ? cardTheme.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardOrderCloseEvent
 */
export var CashCardOrderClose = function () { return ({
    name: "CashCard Order Close",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Order",
    }
}); };
/**
 * @see CashCardOrderConfirmDisclosureEvent
 */
export var CashCardOrderConfirmDisclosure = function () { return ({
    name: "CashCard Order ConfirmDisclosure",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Order",
    }
}); };
/**
 * @see CashCardOrderExpectShipmentEvent
 */
export var CashCardOrderExpectShipment = function () { return ({
    name: "CashCard Order ExpectShipment",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Order",
    }
}); };
/**
 * @see CashCardOrderFirstSubmissionEvent
 */
export var CashCardOrderFirstSubmission = function () { return ({
    name: "CashCard Order FirstSubmission",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Order",
    }
}); };
/**
 * @see CashCardOrderTapEvent
 */
export var CashCardOrderTap = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, hasCustomization = _a.hasCustomization, patternStrokeCount = _a.patternStrokeCount, patternStampCount = _a.patternStampCount;
    return ({
        name: "CashCard Order Tap",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Order",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_customization: hasCustomization !== undefined && hasCustomization !== null ? hasCustomization.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pattern_stroke_count: patternStrokeCount !== undefined && patternStrokeCount !== null ? patternStrokeCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pattern_stamp_count: patternStampCount !== undefined && patternStampCount !== null ? patternStampCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeStartEvent
 */
export var CashCardCustomizeStart = function (_a) {
    var type = _a.type;
    return ({
        name: "CashCard Customize Start",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeSelectDesignAssetEvent
 */
export var CashCardCustomizeSelectDesignAsset = function (_a) {
    var id = _a.id;
    return ({
        name: "CashCard Customize SelectDesignAsset",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            id: id !== undefined && id !== null ? id.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeSelectStyleEvent
 */
export var CashCardCustomizeSelectStyle = function (_a) {
    var themeToken = _a.themeToken, clientScenario = _a.clientScenario, flowToken = _a.flowToken, index = _a.index;
    return ({
        name: "CashCard Customize SelectStyle",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            theme_token: themeToken !== undefined && themeToken !== null ? themeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizePreviewStyleEvent
 */
export var CashCardCustomizePreviewStyle = function () { return ({
    name: "CashCard Customize PreviewStyle",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizePreviewPerformanceEvent
 */
export var CashCardCustomizePreviewPerformance = function (_a) {
    var device = _a.device, gpu = _a.gpu, theme = _a.theme, averageFps = _a.averageFps, engine = _a.engine;
    return ({
        name: "CashCard Customize PreviewPerformance",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            device: device !== undefined && device !== null ? device.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            gpu: gpu !== undefined && gpu !== null ? gpu.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            theme: theme !== undefined && theme !== null ? theme.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            average_fps: averageFps !== undefined && averageFps !== null ? averageFps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            engine: engine !== undefined && engine !== null ? engine.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeCloseEvent
 */
export var CashCardCustomizeClose = function (_a) {
    var type = _a.type;
    return ({
        name: "CashCard Customize Close",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeScrollToThemeEvent
 */
export var CashCardCustomizeScrollToTheme = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, index = _a.index, themeToken = _a.themeToken;
    return ({
        name: "CashCard Customize ScrollToTheme",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            theme_token: themeToken !== undefined && themeToken !== null ? themeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapEvent
 */
export var CashCardCustomizeTap = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, hasCustomization = _a.hasCustomization;
    return ({
        name: "CashCard Customize Tap",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_customization: hasCustomization !== undefined && hasCustomization !== null ? hasCustomization.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapPatternEvent
 */
export var CashCardCustomizeTapPattern = function () { return ({
    name: "CashCard Customize TapPattern",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapUndoEvent
 */
export var CashCardCustomizeTapUndo = function (_a) {
    var undoingPattern = _a.undoingPattern, undoMethod = _a.undoMethod;
    return ({
        name: "CashCard Customize TapUndo",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            undoing_pattern: undoingPattern !== undefined && undoingPattern !== null ? undoingPattern.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            undo_method: undoMethod !== undefined && undoMethod !== null ? undoMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapUndoDialogConfirmEvent
 */
export var CashCardCustomizeTapUndoDialogConfirm = function () { return ({
    name: "CashCard Customize TapUndoDialogConfirm",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapUndoDialogCancelEvent
 */
export var CashCardCustomizeTapUndoDialogCancel = function () { return ({
    name: "CashCard Customize TapUndoDialogCancel",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapClearEvent
 */
export var CashCardCustomizeTapClear = function () { return ({
    name: "CashCard Customize TapClear",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapSaveEvent
 */
export var CashCardCustomizeTapSave = function () { return ({
    name: "CashCard Customize TapSave",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapBackEvent
 */
export var CashCardCustomizeTapBack = function () { return ({
    name: "CashCard Customize TapBack",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapBackConfirmEvent
 */
export var CashCardCustomizeTapBackConfirm = function () { return ({
    name: "CashCard Customize TapBackConfirm",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapBackStayEvent
 */
export var CashCardCustomizeTapBackStay = function () { return ({
    name: "CashCard Customize TapBackStay",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeTapDrawEvent
 */
export var CashCardCustomizeTapDraw = function (_a) {
    var newMode = _a.newMode, isPattern = _a.isPattern;
    return ({
        name: "CashCard Customize TapDraw",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            new_mode: newMode !== undefined && newMode !== null ? newMode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_pattern: isPattern !== undefined && isPattern !== null ? isPattern.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapStampsEvent
 */
export var CashCardCustomizeTapStamps = function (_a) {
    var isPattern = _a.isPattern;
    return ({
        name: "CashCard Customize TapStamps",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            is_pattern: isPattern !== undefined && isPattern !== null ? isPattern.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapCashtagEvent
 */
export var CashCardCustomizeTapCashtag = function (_a) {
    var newVisibility = _a.newVisibility;
    return ({
        name: "CashCard Customize TapCashtag",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            new_visibility: newVisibility !== undefined && newVisibility !== null ? newVisibility.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapPatternCommitEvent
 */
export var CashCardCustomizeTapPatternCommit = function (_a) {
    var patternDensity = _a.patternDensity, uniqueStrokeCount = _a.uniqueStrokeCount, uniqueStampCount = _a.uniqueStampCount;
    return ({
        name: "CashCard Customize TapPatternCommit",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            pattern_density: patternDensity !== undefined && patternDensity !== null ? patternDensity.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            unique_stroke_count: uniqueStrokeCount !== undefined && uniqueStrokeCount !== null ? uniqueStrokeCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            unique_stamp_count: uniqueStampCount !== undefined && uniqueStampCount !== null ? uniqueStampCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeTapPatternSliderEvent
 */
export var CashCardCustomizeTapPatternSlider = function () { return ({
    name: "CashCard Customize TapPatternSlider",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Customize",
    }
}); };
/**
 * @see CashCardCustomizeDeleteStampEvent
 */
export var CashCardCustomizeDeleteStamp = function (_a) {
    var id = _a.id, isPattern = _a.isPattern, method = _a.method;
    return ({
        name: "CashCard Customize DeleteStamp",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            id: id !== undefined && id !== null ? id.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_pattern: isPattern !== undefined && isPattern !== null ? isPattern.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            method: method !== undefined && method !== null ? method.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardCustomizeUpdateStampEvent
 */
export var CashCardCustomizeUpdateStamp = function (_a) {
    var id = _a.id, isPattern = _a.isPattern, type = _a.type;
    return ({
        name: "CashCard Customize UpdateStamp",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Customize",
            id: id !== undefined && id !== null ? id.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_pattern: isPattern !== undefined && isPattern !== null ? isPattern.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardActivateStartEvent
 */
export var CashCardActivateStart = function () { return ({
    name: "CashCard Activate Start",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Activate",
    }
}); };
/**
 * @see CashCardActivateCompleteEvent
 */
export var CashCardActivateComplete = function () { return ({
    name: "CashCard Activate Complete",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Activate",
    }
}); };
/**
 * @see CashCardManageEnableEvent
 */
export var CashCardManageEnable = function () { return ({
    name: "CashCard Manage Enable",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Manage",
    }
}); };
/**
 * @see CashCardManageDisableEvent
 */
export var CashCardManageDisable = function () { return ({
    name: "CashCard Manage Disable",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Manage",
    }
}); };
/**
 * @see CashCardManageHideInformationEvent
 */
export var CashCardManageHideInformation = function () { return ({
    name: "CashCard Manage HideInformation",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Manage",
    }
}); };
/**
 * @see CashCardManageUnhideInformationEvent
 */
export var CashCardManageUnhideInformation = function () { return ({
    name: "CashCard Manage UnhideInformation",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Manage",
    }
}); };
/**
 * @see CashCardViewCopyValueEvent
 */
export var CashCardViewCopyValue = function (_a) {
    var copiedValue = _a.copiedValue;
    return ({
        name: "CashCard View CopyValue",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "View",
            copied_value: copiedValue !== undefined && copiedValue !== null ? copiedValue.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardPurchasePendingEvent
 */
export var CashCardPurchasePending = function (_a) {
    var parentMerchantToken = _a.parentMerchantToken, merchantName = _a.merchantName;
    return ({
        name: "CashCard Purchase Pending",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Purchase",
            parent_merchant_token: parentMerchantToken !== undefined && parentMerchantToken !== null ? parentMerchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_name: merchantName !== undefined && merchantName !== null ? merchantName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardPurchaseInsufficientFundsEvent
 */
export var CashCardPurchaseInsufficientFunds = function () { return ({
    name: "CashCard Purchase InsufficientFunds",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Purchase",
    }
}); };
/**
 * @see CashCardAtmWithdrawalSettledEvent
 */
export var CashCardAtmWithdrawalSettled = function () { return ({
    name: "CashCard AtmWithdrawal Settled",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "AtmWithdrawal",
    }
}); };
/**
 * @see CashCardAtmWithdrawalInsufficientFundsEvent
 */
export var CashCardAtmWithdrawalInsufficientFunds = function () { return ({
    name: "CashCard AtmWithdrawal InsufficientFunds",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "AtmWithdrawal",
    }
}); };
/**
 * @see CashCardNullStateViewEvent
 */
export var CashCardNullStateView = function (_a) {
    var nullStateToken = _a.nullStateToken, analyticsKey = _a.analyticsKey, index = _a.index;
    return ({
        name: "CashCard NullState View",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "NullState",
            null_state_token: nullStateToken !== undefined && nullStateToken !== null ? nullStateToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            analytics_key: analyticsKey !== undefined && analyticsKey !== null ? analyticsKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardNullStateSelectEvent
 */
export var CashCardNullStateSelect = function (_a) {
    var nullStateToken = _a.nullStateToken, analyticsKey = _a.analyticsKey, index = _a.index;
    return ({
        name: "CashCard NullState Select",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "NullState",
            null_state_token: nullStateToken !== undefined && nullStateToken !== null ? nullStateToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            analytics_key: analyticsKey !== undefined && analyticsKey !== null ? analyticsKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardHero3DSwipesEvent
 */
export var CashCardHero3DSwipes = function (_a) {
    var landedOnFront = _a.landedOnFront, landedOnBack = _a.landedOnBack;
    return ({
        name: "CashCard Hero3D Swipes",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Hero3D",
            landed_on_front: landedOnFront !== undefined && landedOnFront !== null ? landedOnFront.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            landed_on_back: landedOnBack !== undefined && landedOnBack !== null ? landedOnBack.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardHero3DPerformanceEvent
 */
export var CashCardHero3DPerformance = function (_a) {
    var gpu = _a.gpu, theme = _a.theme, averageFps = _a.averageFps, engine = _a.engine;
    return ({
        name: "CashCard Hero3D Performance",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Hero3D",
            gpu: gpu !== undefined && gpu !== null ? gpu.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            theme: theme !== undefined && theme !== null ? theme.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            average_fps: averageFps !== undefined && averageFps !== null ? averageFps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            engine: engine !== undefined && engine !== null ? engine.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardTabViewEvent
 */
export var CashCardTabView = function () { return ({
    name: "CashCard Tab View",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Tab",
    }
}); };
/**
 * @see CashCardTabErrorEvent
 */
export var CashCardTabError = function (_a) {
    var retryCount = _a.retryCount;
    return ({
        name: "CashCard Tab Error",
        parameters: {
            cdf_entity: "CashCard",
            cdf_action: "Tab",
            retry_count: retryCount !== undefined && retryCount !== null ? retryCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashCardTransactionFirstAttemptEvent
 */
export var CashCardTransactionFirstAttempt = function () { return ({
    name: "CashCard Transaction FirstAttempt",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Transaction",
    }
}); };
/**
 * @see CashCardTransactionFirstSuccessEvent
 */
export var CashCardTransactionFirstSuccess = function () { return ({
    name: "CashCard Transaction FirstSuccess",
    parameters: {
        cdf_entity: "CashCard",
        cdf_action: "Transaction",
    }
}); };
